import { render, staticRenderFns } from "./BannerShopBlock.vue?vue&type=template&id=70824632&"
import script from "./BannerShopBlock.vue?vue&type=script&lang=js&"
export * from "./BannerShopBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerShopBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports